import { jsx as p, Fragment as it } from "react/jsx-runtime";
import { createElement as pt, useLayoutEffect as wt, useRef as nt, useState as st, cloneElement as ot, useMemo as z, createContext as yt, useContext as xt } from "react";
class St {
  constructor(t) {
    this.nodes = [], this.fonts = /* @__PURE__ */ new Map(), this.rootNode = { ...t, x: 0, y: 0 }, this.traverse(t, (e) => {
      this.nodes.push(e), e.type === "TEXT" && this.deriveFontsFrom(e);
    });
  }
  traverse(t, e) {
    if (t.children != null)
      for (const r of t.children)
        e(r), this.traverse(r, e);
  }
  deriveFontsFrom(t) {
    var r;
    if ((r = t.segments) == null || r.forEach((n) => {
      const s = n.fontName.family + " " + n.fontName.style;
      this.fonts.set(s, n.fontName);
    }), t.fontName == null)
      return;
    const e = t.fontName.family + " " + t.fontName.style;
    this.fonts.set(e, t.fontName);
  }
}
var F = /* @__PURE__ */ ((i) => (i[i.MenuItemTitle = 0] = "MenuItemTitle", i[i.MenuItemPrice = 1] = "MenuItemPrice", i))(F || {});
class me extends St {
  constructor(t) {
    var e;
    super(t), this.designId = ((e = this.rootNode.pluginData) == null ? void 0 : e.smartTextEntity.id) ?? null, this.companyId = null, this.menuItemIds = /* @__PURE__ */ new Set(), this.traverse(t, (r) => this.findAndAddMenuId(r));
  }
  findAndAddMenuId(t) {
    var r;
    const e = (r = t.pluginData) == null ? void 0 : r.smartTextEntity;
    e != null && F[e.type] != null && this.menuItemIds.add(e.id);
  }
}
class g {
  constructor(t, e, r, n = 1) {
    this.r = t, this.g = e, this.b = r, this.a = n;
  }
  blendWith(t) {
    const e = 1 - (1 - t.a) * (1 - this.a), r = t.r * t.a / e + this.r * this.a * (1 - t.a) / e, n = t.g * t.a / e + this.g * this.a * (1 - t.a) / e, s = t.b * t.a / e + this.b * this.a * (1 - t.a) / e;
    return new g(r, n, s, e);
  }
  toString() {
    return `rgba(${Math.round(this.r * 255)}, ${Math.round(this.g * 255)}, ${Math.round(this.b * 255)}, ${Math.round(this.a * 100) / 100})`;
  }
  static blend(...t) {
    return t.length === 0 ? new g(0, 0, 0, 0) : t.reduce((e, r) => e.blendWith(r), t[0]);
  }
  static from(t) {
    return new g(t.r, t.g, t.b, t.a);
  }
  static fromSolidPaint(t) {
    return new g(t.color.r, t.color.g, t.color.b, t.opacity);
  }
  static fromPaints(t) {
    return t.flatMap((r) => r.type !== "SOLID" ? [] : [g.fromSolidPaint(r)]);
  }
}
function l(i) {
  if (i != null)
    return i.toFixed(2) + "px";
}
function R(i, t) {
  if (i != null)
    return i.toFixed(t) + "%";
}
function L(i) {
  return i == null ? void 0 : i.replace(/_/g, "-").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Et(i) {
  return i.reduce((t, e) => t.set(e.id, e), /* @__PURE__ */ new Map());
}
class vt {
  static from(t) {
    return t == null ? { value: t } : typeof t != "object" ? { value: t } : t instanceof CSSNumericValue ? { value: t } : t;
  }
}
class M {
  constructor() {
    this.enabled = !0;
  }
  yield() {
    if (!this.enabled)
      return {};
    const t = {}, e = {};
    return this.traverseMethods((r) => {
      var o;
      const n = this.getAdapterFromMethod(r), s = (o = n.value) == null ? void 0 : o.toString();
      if (s != null && s !== "" && (t[r.name] = s, this.logUnsupportedStyle(r.name, s)), n.override != null) {
        for (const a of Object.keys(n.override))
          if (a in e)
            throw new Error(`Style Overriding Conflict: there is already another ${a}`);
        Object.assign(e, n.override);
      }
    }), { ...t, ...e };
  }
  getAdapterFromMethod(t) {
    const e = t.call(this);
    return vt.from(e);
  }
  async logUnsupportedStyle(t, e) {
    await new Promise(requestAnimationFrame), await new Promise(requestAnimationFrame);
    const r = L(t);
    CSS.supports(r, e.toString()) || console.warn(`${M.name}: ${r} doesn't support value of {${e}}`);
  }
  traverseMethods(t) {
    const e = /* @__PURE__ */ new Set();
    let r = Object.getPrototypeOf(this);
    for (; r !== M.prototype; ) {
      for (const n of Object.getOwnPropertyNames(r)) {
        if (e.has(n) || n === this.yield.name || n === this.traverseMethods.name || n === "constructor")
          continue;
        const s = r[n];
        typeof s == "function" && (t(s), e.add(n));
      }
      r = Object.getPrototypeOf(r);
    }
  }
}
class Rt extends M {
  constructor(t) {
    super(), this.mixin = t;
  }
  static with(...t) {
    return t;
  }
}
class Y {
  constructor(t) {
    this.unitValue = t;
  }
  get value() {
    var t;
    if (((t = this.unitValue) == null ? void 0 : t.value) != null)
      switch (this.unitValue.unit) {
        case "PIXELS":
          return CSS.px(this.unitValue.value);
        case "PERCENT":
          return CSS.percent(this.unitValue.value);
        default:
          return;
      }
  }
}
class At {
  constructor(t) {
    this.mixin = t;
  }
  get value() {
    return this.shouldEmitCapFallback ? this.capHeight : this.lineHeight.equals(1) ? null : this.lineHeight;
  }
  get shouldEmitCapFallback() {
    return !(this.mixin.leadingTrim !== "CAP_HEIGHT" || this.capSupported);
  }
  get lineHeight() {
    return new Y(this.mixin.lineHeight).value ?? CSS.number(1);
  }
  /**
   *
   */
  get capHeight() {
    const t = this.mixin.height ?? 1, e = this.mixin.fontSize ?? 1, r = t / e;
    return r > 1 ? CSS.number(1) : CSS.number(r);
  }
  get capSupported() {
    return CSS.supports("text-edge: cap") && CSS.supports("leading-trim: both");
  }
}
class at {
  constructor(t) {
    var e, r, n;
    this.family = ((e = t.fontName) == null ? void 0 : e.family) ?? "serif", this.weight = t.fontWeight ?? this.getWeight((r = t.fontName) == null ? void 0 : r.style), this.style = this.getStyle((n = t.fontName) == null ? void 0 : n.style), this.size = t.fontSize ? CSS.px(t.fontSize) : CSS.em(1), this.lineHeight = new At(t);
  }
  get value() {
    return this.lineHeight.value == null ? `${this.style} ${this.weight} ${this.size} ${this.family}` : `${this.style} ${this.weight} ${this.size}/${this.lineHeight.value} ${this.family}`;
  }
  getStyle(t) {
    return t == null ? "normal" : t.search(/slant|italic/i) >= 0 ? "italic" : "normal";
  }
  getWeight(t) {
    switch (t == null ? void 0 : t.replace("Italic", "").trim()) {
      case "Thin":
        return 100;
      case "Extra Light":
        return 200;
      case "Light":
        return 300;
      case "Regular":
        return 400;
      case "Medium":
        return 500;
      case "Semi Bold":
        return 600;
      case "Bold":
        return 700;
      case "Extra Bold":
        return 800;
      case "Black":
        return 900;
      default:
        return 400;
    }
  }
}
class ht {
  constructor(t = []) {
    this.fills = t, this.hasImage = !!this.fills.some((e) => e.type.includes("IMAGE")), this.hasGradient = !!this.fills.some((e) => e.type.includes("GRADIENT")), this.hasBlendMode = !!this.fills.some((e) => e.blendMode), this.mixable = this.hasImage || this.hasGradient || this.hasBlendMode;
  }
}
class bt extends Rt {
  constructor() {
    super(...arguments), this.fillsHint = new ht(this.mixin.fills);
  }
  background() {
    this.fillsHint.hasImage || this.fillsHint.hasGradient;
  }
  color() {
    if (this.mixin.fills != null && !this.fillsHint.hasImage && !this.fillsHint.hasGradient)
      return g.blend(...g.fromPaints(this.mixin.fills)).toString();
  }
  whiteSpace() {
    var t;
    if ((t = this.mixin.characters) != null && t.includes(`
`))
      return "break-spaces";
  }
  letterSpacing() {
    return new Y(this.mixin.letterSpacing);
  }
  textDecoration() {
    var t;
    return (t = this.mixin.textDecoration) == null ? void 0 : t.toLowerCase();
  }
  font() {
    return new at(this.mixin);
  }
}
class Q {
  constructor(t, e, r) {
    this.node = t, this.parentNode = e, this.resolvers = r;
  }
  get wrappers() {
    return [];
  }
  /**
   * Applies the `wrappers` by nesting them into each other.
   *
   * @example DesignNode[DesignNode[DesignNode[DesignNode]]]
   */
  nest(...t) {
    return t.reduceRight((e, r) => ({ ...r, children: [...r.children, e] }));
  }
}
class Tt {
  constructor(t) {
    this.element = t;
  }
  get textContent() {
    return this.element.node.characters ?? "";
  }
  resolve() {
    const t = this.getSmartText();
    return t ?? this.element.node.characters;
  }
  getSmartText() {
    var r;
    const t = (r = this.element.node.pluginData) == null ? void 0 : r.smartTextEntity;
    if (t == null)
      return;
    const e = this.element.resolvers.transformText(this.textContent, t);
    if (e != null)
      return e;
  }
}
class U {
  constructor(t) {
    this.node = t;
  }
  getElementChildren() {
    if (this.node instanceof Q && this.node.node.type === "TEXT") {
      const t = this.node.node.segments;
      return t != null ? t.map((r, n) => new U({
        type: "span",
        attributes: { style: new bt(r).yield() },
        children: [r.characters]
      }).toReactElement(n)) : new Tt(this.node).resolve();
    }
    return this.node.children.map((t, e) => typeof t == "string" ? t : new U(t).toReactElement(e));
  }
  toReactElement(t) {
    const e = { ...this.node.attributes, key: t }, r = this.getElementChildren();
    return pt(this.node.type, e, r);
  }
}
class Nt {
  constructor(t, e) {
    this.mixin = t, this.parentMixin = e, this.auto = this.isAutoPositioned();
  }
  parentHasAutoLayout() {
    return !(this.parentMixin.layoutMode == null || this.parentMixin.layoutMode === "NONE");
  }
  isAutoPositioned() {
    return this.mixin.layoutPositioning === "ABSOLUTE" ? !1 : !!this.parentHasAutoLayout();
  }
}
class $t {
  constructor(t) {
    this.element = t, this.fills = new ht(this.element.node.fills), this.position = new Nt(this.element.node, this.element.parentNode ?? {});
  }
}
class Mt extends M {
  constructor(t) {
    super(), this.wrappers = [], this.fragments = [], this.node = t.node, this.parentNode = t.parentNode ?? {}, this.getURLFromHash = t.resolvers.imageHash, this.hints = new $t(t);
  }
}
class It {
  constructor(t = [[1, 0, 0], [0, 1, 0]]) {
    this.transform = t;
  }
  get override() {
    if (this.isTransformed())
      return {
        transformOrigin: "0 0"
      };
  }
  /**
   * @example
   * `matrix(1.2, 0.2, -1, 0.9, 0, 0)`
   */
  get value() {
    if (!this.isTransformed())
      return;
    const [[t, e], [r, n]] = this.transform;
    return `matrix(${t},${r},${e},${n},0,0)`;
  }
  isTransformed() {
    const [[t, e], [r, n]] = this.transform;
    return !(t === 1 && r === 0 && e === 0 && n === 1);
  }
}
class G extends Mt {
  position() {
    return this.hints.position.auto ? "relative" : "absolute";
  }
  top() {
    var t;
    if (!this.hints.position.auto)
      return this.parentNode.type === "FRAME" ? l(this.node.y) : l((this.node.y ?? 0) - (((t = this.parentNode) == null ? void 0 : t.y) ?? 0));
  }
  left() {
    var t;
    if (!this.hints.position.auto)
      return this.parentNode.type === "FRAME" ? l(this.node.x) : l((this.node.x ?? 0) - (((t = this.parentNode) == null ? void 0 : t.x) ?? 0));
  }
  width() {
    return l(this.node.width);
  }
  height() {
    return l(this.node.height);
  }
  transform() {
    if (this.node.relativeTransform != null && this.node.type !== "GROUP")
      return new It(this.node.relativeTransform);
  }
}
class ut {
  constructor(t) {
    this.solidPaint = t;
  }
  get value() {
    return `rgba(${Math.round(this.solidPaint.color.r * 255)}, ${Math.round(this.solidPaint.color.g * 255)}, ${Math.round(this.solidPaint.color.b * 255)}, ${Math.round(this.solidPaint.opacity ?? 1)})`;
  }
}
var X;
((i) => {
  ((t) => {
    t[t.a = 0] = "a", t[t.DisplayP3 = 1] = "DisplayP3", t[t.c = 2] = "c", t[t.d = 3] = "d";
  })(i.Profile || (i.Profile = {})), i.DEFAULT_MANAGEMENT = {
    colorProfile: 0,
    colorspaceConversion: 0
  };
})(X || (X = {}));
const A = X, y = class y {
  constructor(t = 0, e = 0) {
    this.x = t, this.y = e;
  }
  clone() {
    return new y(this.x, this.y);
  }
  add(t) {
    return new y(this.x + t.x, this.y + t.y);
  }
  subtract(t) {
    return new y(this.x - t.x, this.y - t.y);
  }
  scale(t) {
    return new y(this.x * t, this.y * t);
  }
  multiply(t) {
    return new y(this.x * t.x, this.y * t.y);
  }
  multiplyScalar(t) {
    return new y(this.x * t, this.y * t);
  }
  divide(t) {
    return new y(this.x / t.x, this.y / t.y);
  }
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  toAngleRAD() {
    return Math.atan2(this.y, this.x);
  }
  lengthSquared() {
    return this.dot(this);
  }
  length() {
    return Math.sqrt(this.lengthSquared());
  }
  unit() {
    const t = this.length();
    return this.scale(t === 0 ? 0 : 1 / t);
  }
  distanceTo(t) {
    return this.subtract(t).length();
  }
  rotate90() {
    return new y(-this.y, this.x);
  }
  static lerp(t, e, r) {
    return {
      x: t.x + (e.x - t.x) * r,
      y: t.y + (e.y - t.y) * r
    };
  }
  static from(t) {
    return new y(t.x, t.y);
  }
};
y.NaN = Object.freeze(Object.seal(new y(NaN, NaN)));
let S = y;
class b {
  constructor() {
    this.m00 = 0, this.m01 = 0, this.m02 = 0, this.m10 = 0, this.m11 = 0, this.m12 = 0;
  }
  static fromNumbers(t, e, r, n, s, o) {
    const a = new b();
    return a.m00 = t, a.m01 = e, a.m02 = r, a.m10 = n, a.m11 = s, a.m12 = o, a;
  }
  static fromVectors(t, e, r) {
    const n = new b();
    return n.m00 = e.x, n.m01 = r.x, n.m02 = t.x, n.m10 = e.y, n.m11 = r.y, n.m12 = t.y, n;
  }
  static from(t) {
    const e = new b();
    return e.m00 = t.m00, e.m01 = t.m01, e.m02 = t.m02, e.m10 = t.m10, e.m11 = t.m11, e.m12 = t.m12, e;
  }
  static fromArray(t) {
    const e = new b();
    return e.m00 = t[0][0], e.m01 = t[0][1], e.m02 = t[0][2], e.m10 = t[1][0], e.m11 = t[1][1], e.m12 = t[1][2], e;
  }
  toJSON() {
    return {
      m00: this.m00,
      m01: this.m01,
      m02: this.m02,
      m10: this.m10,
      m11: this.m11,
      m12: this.m12
    };
  }
  toArray() {
    return [[this.m00, this.m01, this.m02], [this.m10, this.m11, this.m12]];
  }
  axisX() {
    return new S(this.m00, this.m10);
  }
  axisY() {
    return new S(this.m01, this.m11);
  }
  offset() {
    return new S(this.m02, this.m12);
  }
  toDegrees() {
    return Math.atan2(this.m10, this.m00) * 180 / Math.PI;
  }
  toScale() {
    const { m00: t, m01: e, m10: r, m11: n } = this;
    return new S(Math.sqrt(t * t + r * r), Math.sqrt(e * e + n * n));
  }
  hasNaN() {
    return this.m00 !== this.m00 && this.m01 !== this.m01 && this.m02 !== this.m02 && this.m10 !== this.m10 && this.m11 !== this.m11 && this.m12 !== this.m12;
  }
  translate(t, e) {
    this.m02 = t * this.m00 + e * this.m01 + this.m02, this.m12 = t * this.m10 + e * this.m11 + this.m12;
  }
  rotate(t) {
    if (t === 0)
      return;
    const e = Math.sin(t), r = Math.cos(t), n = r * this.m00 + e * this.m01, s = r * this.m01 - e * this.m00, o = r * this.m10 + e * this.m11, a = r * this.m11 - e * this.m10;
    this.m00 = n, this.m01 = s, this.m10 = o, this.m11 = a;
  }
  scale(t, e) {
    this.m00 *= t, this.m01 *= e, this.m10 *= t, this.m11 *= e;
  }
  multiply(t) {
    "m00" in t || (t = b.fromArray(t));
    const e = this.m00 * t.m00 + this.m01 * t.m10, r = this.m00 * t.m01 + this.m01 * t.m11, n = this.m00 * t.m02 + this.m01 * t.m12 + this.m02, s = this.m10 * t.m00 + this.m11 * t.m10, o = this.m10 * t.m01 + this.m11 * t.m11, a = this.m10 * t.m02 + this.m11 * t.m12 + this.m12;
    return this.m00 = e, this.m01 = r, this.m02 = n, this.m10 = s, this.m11 = o, this.m12 = a, this;
  }
  determinant() {
    return this.m00 * this.m11 - this.m01 * this.m10;
  }
  invert() {
    const t = 1 / this.determinant();
    if (!isFinite(t))
      return this;
    if (Number.isNaN(t))
      return this;
    const e = b.fromNumbers(
      this.m11 * t,
      -this.m01 * t,
      (this.m01 * this.m12 - this.m11 * this.m02) * t,
      -this.m10 * t,
      this.m00 * t,
      (this.m10 * this.m02 - this.m00 * this.m12) * t
    );
    return this.m00 = e.m00, this.m01 = e.m01, this.m02 = e.m02, this.m10 = e.m10, this.m11 = e.m11, this.m12 = e.m12, this;
  }
  transformPoint(t) {
    return new S(
      this.m00 * t.x + this.m01 * t.y + this.m02,
      this.m10 * t.x + this.m11 * t.y + this.m12
    );
  }
  transformDirection(t) {
    return new S(
      this.m00 * t.x + this.m01 * t.y,
      this.m10 * t.x + this.m11 * t.y
    );
  }
  inverseTransformPoint(t) {
    const e = 1 / this.determinant();
    if (!isFinite(e))
      throw TypeError("Value must be finite");
    const r = (this.m11 * t.x - this.m01 * t.y + this.m01 * this.m12 - this.m11 * this.m02) * e, n = (this.m00 * t.y - this.m10 * t.x + this.m10 * this.m02 - this.m00 * this.m12) * e;
    return new S(r, n);
  }
}
function B(i) {
  return Math.round(i * 255);
}
function N(i) {
  return ("00" + Math.round(i * 255).toString(16).toUpperCase()).slice(-2);
}
function Lt(i) {
  return `${N(i.r)}${N(i.g)}${N(i.b)}`;
}
function Pt(i, t = 1) {
  const { r: e, g: r, b: n, a: s } = i;
  return `${N(e)}${N(r)}${N(n)}${N(s * t)}`;
}
class Dt {
  constructor(t, e) {
    this.name = t, this.resolver = e;
  }
  get value() {
    return `var(--${L(this.name ?? "unnamed")}, ${this.resolver.value})`;
  }
  get definition() {
    return `--${L(this.name ?? "unnamed")}: ${this.resolver.value}`;
  }
}
class $ {
  constructor(t, e = 1, r = A.DEFAULT_MANAGEMENT, n) {
    if (this.color = t, this.opacity = e, this.colorManagement = r, this.variable = n, t.r > 1 || t.g > 1 || t.b > 1)
      throw new RangeError(`Expected normalized color values (between 0 and 1) but got (${t.r}, ${t.g}, ${t.b})`);
  }
  get value() {
    const t = this.getSuggestion();
    return t ?? (this.color.a !== 1 || this.opacity !== 1 ? $.toRGBA(this.color, this.opacity) : this.colorManagement.colorProfile === A.Profile.DisplayP3 ? $.toDisplayP3(this.color, this.opacity) : $.toHex(this.color));
  }
  getSuggestion() {
    return this.variable == null ? null : this.variable.codeSyntax.WEB != null ? this.variable.codeSyntax.WEB : new Dt(this.variable.name, this).value;
  }
}
((i) => {
  function t(n, s = 1) {
    if (n.a !== 1 && s === 1) {
      const a = Lt(n);
      return a[0] === a[1] && a[2] === a[3] && a[4] === a[5] ? `#${a[0]}${a[2]}${a[4]}` : `#${a}`;
    }
    const o = Pt(n, s);
    return o[0] === o[1] && o[2] === o[3] && o[4] === o[5] && o[6] === o[7] ? `#${o[0]}${o[2]}${o[4]}${o[6]}` : `#${o}`;
  }
  i.toHex = t;
  function e(n, s = 1) {
    const { r: o, g: a, b: h, a: d = 1 } = n;
    return `rgba(${B(o)}, ${B(a)}, ${B(h)}, ${(d * s).toFixed(2)})`;
  }
  i.toRGBA = e;
  function r(n, s = 1) {
    const { r: o, g: a, b: h, a: d = 1 } = n, I = d * s;
    return `color(display-p3 ${o.toFixed(4)} ${a.toFixed(4)} ${h.toFixed(4)} / ${I.toFixed(2)})`;
  }
  i.toDisplayP3 = r;
})($ || ($ = {}));
const C = $;
function H(i) {
  return i.map((t) => t.value).join(", ");
}
class f {
  constructor(t, e) {
    if (this.data = [], this.rows = 0, this.columns = 0, t instanceof f)
      return t.clone();
    if (typeof t == "number" && t >= 0)
      if (typeof e == "number" && e >= 0)
        for (let r = 0; r < t; r++)
          this.data.push(new Float64Array(e));
      else
        throw new TypeError("nColumns must be a positive integer");
    else if (t instanceof Array) {
      if (t[0] == null)
        throw new TypeError("Data must be a 2D array with at least one element");
      const r = t;
      t = r.length, e = t ? r[0].length : 0;
      for (let n = 0; n < t; n++) {
        if (r[n].length !== e)
          throw new RangeError("Inconsistent array dimensions");
        if (!r[n].every((s) => typeof s == "number"))
          throw new TypeError("Input data contains non-numeric values");
        this.data.push(Float64Array.from(r[n]));
      }
    } else
      throw new TypeError("First argument must be a positive number or an array");
    this.rows = t, this.columns = e;
  }
  subMatrix(t, e, r, n) {
    const s = new f(e - t + 1, n - r + 1);
    for (let o = t; o <= e; o++)
      for (let a = r; a <= n; a++)
        s.set(o - t, a - r, this.get(o, a));
    return s;
  }
  subMatrixRow(t, e = 0, r = this.columns - 1) {
    if (e > r || e < 0 || e >= this.columns || r < 0 || r >= this.columns)
      throw new RangeError("Argument out of range");
    const n = new f(t.length, r - e + 1);
    for (let s = 0; s < t.length; s++)
      for (let o = e; o <= r; o++) {
        if (t[s] < 0 || t[s] >= this.rows)
          throw new RangeError(`Row index out of range: ${t[s]}`);
        n.set(s, o - e, this.get(t[s], o));
      }
    return n;
  }
  to2DArray() {
    const t = [];
    for (let e = 0; e < this.rows; e++) {
      t.push([]);
      for (let r = 0; r < this.columns; r++)
        t[e].push(this.get(e, r));
    }
    return t;
  }
  clone() {
    const t = new f(this.rows, this.columns);
    for (let e = 0; e < this.rows; e++)
      for (let r = 0; r < this.columns; r++)
        t.set(e, r, this.get(e, r));
    return t;
  }
  isSquare() {
    return this.rows === this.columns;
  }
  set(t, e, r) {
    return this.data[t][e] = r, this;
  }
  get(t, e) {
    return this.data[t][e];
  }
  static fill(t, e = t, r = 1) {
    const n = Math.min(t, e), s = new f(t, e);
    for (let o = 0; o < n; o++)
      s.set(o, o, r);
    return s;
  }
  static ensure(t) {
    return t instanceof f ? t : new f(t);
  }
}
function Ct(i, t) {
  if (Math.abs(i) > Math.abs(t)) {
    const e = t / i;
    return Math.abs(i) * Math.sqrt(1 + e * e);
  }
  if (t !== 0) {
    const e = i / t;
    return Math.abs(t) * Math.sqrt(1 + e * e);
  }
  return 0;
}
class Ot {
  constructor(t) {
    t = f.ensure(t);
    const e = t.clone(), r = new Float64Array(t.columns);
    let n, s, o, a;
    for (a = 0; a < t.columns; a++) {
      let h = 0;
      for (o = a; o < t.rows; o++)
        h = Ct(h, e.get(o, a));
      if (h !== 0) {
        for (e.get(a, a) < 0 && (h = -h), o = a; o < t.rows; o++)
          e.set(o, a, e.get(o, a) / h);
        for (e.set(a, a, e.get(a, a) + 1), n = a + 1; n < t.columns; n++) {
          for (s = 0, o = a; o < t.rows; o++)
            s += e.get(o, a) * e.get(o, n);
          for (s = -s / e.get(a, a), o = a; o < t.rows; o++)
            e.set(o, n, e.get(o, n) + s * e.get(o, a));
        }
        r[a] = -h;
      }
    }
    this.QR = e, this.RDiag = r;
  }
  solve(t) {
    if (t = f.ensure(t), t.rows !== this.QR.rows)
      throw new Error("Matrix row dimensions must agree");
    if (!this.isFullRank())
      throw new Error("Matrix is rank deficient");
    const e = t.clone();
    let r, n, s, o;
    for (r = 0; r < this.QR.columns; r++)
      for (o = 0; o < t.columns; o++) {
        for (n = 0, s = r; s < this.QR.rows; s++)
          n += this.QR.get(s, r) * e.get(s, o);
        for (n = -n / this.QR.get(r, r), s = r; s < this.QR.rows; s++)
          e.set(s, o, e.get(s, o) + n * this.QR.get(s, r));
      }
    for (r = this.QR.columns - 1; r >= 0; r--) {
      for (o = 0; o < t.columns; o++)
        e.set(r, o, e.get(r, o) / this.RDiag[r]);
      for (s = 0; s < r; s++)
        for (o = 0; o < t.columns; o++)
          e.set(s, o, e.get(s, o) - e.get(r, o) * this.QR.get(s, r));
    }
    return e.subMatrix(0, this.QR.columns - 1, 0, t.columns - 1);
  }
  isFullRank() {
    const t = this.QR.columns;
    for (let e = 0; e < t; e++)
      if (this.RDiag[e] === 0)
        return !1;
    return !0;
  }
}
class Ht {
  constructor(t) {
    t = f.ensure(t);
    const e = t.clone(), r = new Float64Array(e.rows), n = new Float64Array(e.rows);
    let s, o;
    for (let a = 0; a < e.rows; a++)
      r[a] = a;
    for (let a = 0; a < e.columns; a++) {
      for (let h = 0; h < e.rows; h++)
        n[h] = e.get(h, a);
      for (let h = 0; h < e.rows; h++) {
        let d = 0;
        const I = Math.min(h, a);
        for (let u = 0; u < I; u++)
          d += e.get(h, u) * n[u];
        n[h] -= d, e.set(h, a, n[h]);
      }
      for (o = a, s = a + 1; s < e.rows; s++)
        Math.abs(n[s]) > Math.abs(n[o]) && (o = s);
      if (o !== a) {
        for (let d = 0; d < e.columns; d++) {
          const I = e.get(o, d);
          e.set(o, d, e.get(a, d)), e.set(a, d, I);
        }
        const h = r[o];
        r[o] = r[a], r[a] = h;
      }
      if (a < e.rows && e.get(a, a) !== 0)
        for (s = a + 1; s < e.rows; s++)
          e.set(s, a, e.get(s, a) / e.get(a, a));
    }
    this.LU = e, this.pivotVector = r;
  }
  isSingular() {
    for (let t = 0; t < this.LU.columns; t++)
      if (this.LU.get(t, t) === 0)
        return !0;
    return !1;
  }
  solve(t) {
    if (t = f.ensure(t), this.LU.rows !== t.rows)
      throw new Error("Invalid matrix dimensions");
    if (this.isSingular())
      throw new Error("LU matrix is singular");
    const e = t.subMatrixRow(this.pivotVector);
    for (let r = 0; r < this.LU.columns; r++)
      for (let n = r + 1; n < this.LU.columns; n++)
        for (let s = 0; s < t.columns; s++)
          e.set(n, s, e.get(n, s) - e.get(r, s) * this.LU.get(n, r));
    for (let r = this.LU.columns - 1; r >= 0; r--) {
      for (let n = 0; n < t.columns; n++)
        e.set(r, n, e.get(r, n) / this.LU.get(r, r));
      for (let n = 0; n < r; n++)
        for (let s = 0; s < t.columns; s++)
          e.set(n, s, e.get(n, s) - e.get(r, s) * this.LU.get(n, r));
    }
    return e;
  }
}
function _(i) {
  const t = Ft([...i, [0, 0, 1]]).to2DArray(), [e, r] = j(t, [0.5, 0.5]), [n, s] = j(t, [1, 0.5]), [o, a] = j(t, [0.5, 1]);
  return [{ x: e, y: r }, { x: n, y: s }, { x: o, y: a }];
}
function j(i, t) {
  return [
    t[0] * i[0][0] + t[1] * i[0][1] + i[0][2],
    t[0] * i[1][0] + t[1] * i[1][1] + i[1][2]
  ];
}
function kt(i, t) {
  return i = f.ensure(i), t = f.ensure(t), i.isSquare() ? new Ht(i).solve(t) : new Ot(i).solve(t);
}
function Ft(i) {
  return i = f.ensure(i), kt(i, f.fill(i.rows));
}
var q;
((i) => {
  class t {
    constructor(u, c) {
      this.color = u, this.normalizedPercent = c;
    }
    get value() {
      return `${this.color.value} ${R(this.normalizedPercent * 100, 2)}`;
    }
  }
  class e {
    constructor(u, c) {
      this.color = u, this.normalizedAngle = c;
    }
    get value() {
      return `${this.color.value} ${this.normalizedAngle * 360}deg`;
    }
    static mapPaint(u, c = A.DEFAULT_MANAGEMENT) {
      return u.gradientStops.map((m) => new e(new C(m.color, u.opacity, c), m.position));
    }
  }
  class r {
    constructor(u, c) {
      this.color = u, this.normalizedPosition = c;
    }
    get value() {
      return `${this.color.value} ${R(this.normalizedPosition * 100 / 2)}`;
    }
    static mapPaint(u, c = A.DEFAULT_MANAGEMENT) {
      return u.gradientStops.map((m) => new r(new C(m.color, u.opacity, c), m.position));
    }
  }
  const h = class h {
    constructor() {
      this.angle = 0, this.stops = [];
    }
    get value() {
      return `linear-gradient(${this.angle}deg, ${H(this.stops)})`;
    }
    static fromColor(u) {
      const c = new h();
      return c.stops = [new t(u, 0), new t(u, 1)], c;
    }
    static fromPaint({ gradientTransform: u, gradientStops: c, opacity: m }, x = A.DEFAULT_MANAGEMENT) {
      if (c.length === 1)
        return h.fromColor(new C(c[0].color, m, x));
      const E = b.fromArray(u);
      E.invert(), E.determinant() < 0 && E.scale(1, -1);
      const T = E.axisY(), w = T.scale(-1).rotate90().unit(), D = T.scale(-1).toAngleRAD(), [v, W] = h.getExtremes(D), O = h.sew(w, S.from(v)), ft = h.sew(w, S.from(W)).distanceTo(O), V = new h();
      return V.angle = (D + Math.PI) * (180 / Math.PI), V.stops = c.map((Z) => {
        const gt = E.transformPoint({ x: Z.position, y: 0.5 }).subtract(O).dot(w) / ft;
        return new t(new C(Z.color, m, x), gt);
      }), V;
    }
    static getExtremes(u) {
      const c = Math.PI / 2;
      return u > 0 && u < c ? [h.DEFAULT_CORNERS.topRight, h.DEFAULT_CORNERS.bottomLeft] : u >= c ? [h.DEFAULT_CORNERS.bottomRight, h.DEFAULT_CORNERS.topLeft] : u <= 0 && u > -c ? [h.DEFAULT_CORNERS.topLeft, h.DEFAULT_CORNERS.bottomRight] : u <= -c ? [h.DEFAULT_CORNERS.bottomLeft, h.DEFAULT_CORNERS.topRight] : [{ x: 0, y: 0 }, { x: 0, y: 0 }];
    }
    static sew(u, c) {
      return u.multiplyScalar(c.dot(u) / u.lengthSquared());
    }
  };
  h.DEFAULT_CORNERS = {
    topLeft: { x: 0, y: 0 },
    topRight: { x: 1, y: 0 },
    bottomLeft: { x: 0, y: 1 },
    bottomRight: { x: 1, y: 1 }
  };
  let n = h;
  i.Linear = n;
  class s {
    constructor() {
      this.centerX = 0, this.centerY = 0, this.width = 0, this.height = 0, this.colorStops = [];
    }
    get value() {
      return `radial-gradient(${R(this.width, 2)} ${R(this.height, 2)} at ${R(this.centerX, 2)} ${R(this.centerY, 2)}, ${H(this.colorStops)})`;
    }
    static fromPaint(u, c = A.DEFAULT_MANAGEMENT) {
      const [{ x: m, y: x }, { x: E, y: T }, { x: w, y: D }] = _(u.gradientTransform), v = new s();
      return v.centerX = m * 100, v.centerY = x * 100, v.width = Math.sqrt((w - m) * (w - m) + (D - x) * (D - x)), v.height = Math.sqrt((E - m) * (E - m) + (T - x) * (T - x)), v.width *= 100, v.height *= 100, v.colorStops = u.gradientStops.map(({ color: W, position: O }) => new t(new C(W, u.opacity, c), O)), v;
    }
  }
  i.Radial = s;
  class o {
    constructor() {
      this.centerX = 0, this.centerY = 0, this.angle = 0, this.colorStops = [];
    }
    get value() {
      return `conic-gradient(from ${Math.round(this.angle)}deg at ${R(this.centerX, 2)} ${R(this.centerY, 2)}, ${H(this.colorStops)})`;
    }
    static fromPaint(u, c = A.DEFAULT_MANAGEMENT) {
      const [{ x: m, y: x }, { x: E, y: T }] = _(u.gradientTransform), w = new o();
      return w.centerX = m * 100, w.centerY = x * 100, w.angle = Math.atan2(T - x, E - m) * 180 / Math.PI + 90, w.angle *= 100, w.colorStops = e.mapPaint(u, c), w;
    }
  }
  i.Conic = o;
  const d = class d {
    constructor() {
      this.colorStops = [];
    }
    get value() {
      return d.CORNERS.map((u) => `linear-gradient(to ${u}, ${H(this.colorStops)}) ${u} / 51% 51% no-repeat`).join(", ");
    }
    static fromPaint(u, c = A.DEFAULT_MANAGEMENT) {
      const m = new d();
      return m.colorStops = r.mapPaint(u, c), m;
    }
  };
  d.CORNERS = ["bottom right", "bottom left", "top left", "top right"];
  let a = d;
  i.Diamond = a;
})(q || (q = {}));
const k = q;
class K {
  constructor(t, e) {
    this.fills = t, this.hashToURL = e;
  }
  get value() {
    return this.fills.toReversed().map((e) => {
      var r;
      return (r = this.fromPaint(e)) == null ? void 0 : r.value;
    }).filter(Boolean).join(", ");
  }
  fromPaint(t) {
    if (t.visible === !1 || t.opacity === 0)
      return null;
    switch (t.type) {
      case "SOLID":
        return new ut(t);
      case "IMAGE":
        return new Ut(t, this.hashToURL);
      case "GRADIENT_LINEAR":
        return k.Linear.fromPaint(t);
      case "GRADIENT_RADIAL":
        return k.Radial.fromPaint(t);
      case "GRADIENT_DIAMOND":
        return k.Diamond.fromPaint(t);
      case "GRADIENT_ANGULAR":
        return k.Conic.fromPaint(t);
      default:
        return null;
    }
  }
}
class Ut {
  constructor(t, e) {
    this.url = "<missing>", this.size = "cover", this.position = "50% 50%", this.repeat = "no-repeat", t.imageHash != null && (this.url = e(t.imageHash));
  }
  get value() {
    return `url(${this.url}) ${this.position} / ${this.size} ${this.repeat}`;
  }
  // static fromImagePaint(imagePaint: ImagePaint) {
  //   imagePaint.filters
  // }
  // static withFillMode() {
  //   return new BackgroundImage("cover")
  // }
  // static withFitMode() {
  //   return new BackgroundImage("contain")
  // }
  // static withTileMode(factor = 1, resolution = { width: 100, height: 100 }) {
  //   const width = resolution.width * factor
  //   const height = resolution.height * factor
  //   return new BackgroundImage(`${px(width)} ${px(height)}`, "0% 0%", "repeat")
  // }
  // static withCropMode(transform: Transform = [[1, 0, 0], [0, 1, 0]], size = { width: 0, height: 0 }) {
  //   const width = 100 / transform[0][0]
  //   const height = 100 / transform[1][1]
  //   const x = -(size.width / transform[0][0]) * transform[0][2]
  //   const y = -(size.height / transform[1][1]) * transform[1][2]
  //   return new BackgroundImage(`${width}% ${height}%`, `${px(x)} ${px(y)}`, "no-repeat")
  // }
}
class zt {
  constructor(t) {
    this.mixin = t, this.align = this.mixin.strokeAlign ?? "CENTER", this.weight = this.mixin.strokeWeight ?? 0, this.weights = [
      this.mixin.strokeTopWeight ?? 0,
      this.mixin.strokeRightWeight ?? 0,
      this.mixin.strokeBottomWeight ?? 0,
      this.mixin.strokeLeftWeight ?? 0
    ], this.hasPaint = this.mixin.strokes != null && this.mixin.strokes.length > 0, this.hasIndividual = this.weights.some((e) => e !== this.weight);
  }
  /**
   * @example top right left bottom
   * @example 2px 0px 6px 2px
   */
  get shorthand() {
    return this.hasIndividual ? this.weights.map(l).join(" ") : l(this.weight);
  }
  /**
   * Offset is calculated assuming that Inside stroke alignment requires no offset.
   */
  get offset() {
    if (this.align !== "INSIDE") {
      if (this.align === "CENTER")
        return this.multipleShorthand(-0.5);
      if (this.align === "OUTSIDE")
        return this.multipleShorthand(-1);
    }
  }
  multipleShorthand(t) {
    return this.hasIndividual ? this.weights.map((e) => l(e * t)).join(" ") : l(this.weight * t);
  }
}
class Gt extends M {
  constructor(t, e) {
    super(), this.mixin = t, this.getURLFromHash = e, this.strokeHint = new zt(this.mixin), this.enabled = this.strokeHint.hasPaint, this.maskGeometry = "linear-gradient(#000 0 0)";
  }
  position() {
    return "absolute";
  }
  inset() {
    return 0;
  }
  zIndex() {
    return -1;
  }
  padding() {
    return this.strokeHint.shorthand;
  }
  margin() {
    return this.strokeHint.offset;
  }
  borderRadius() {
    return "inherit";
  }
  background() {
    return new K(this.mixin.strokes ?? [], this.getURLFromHash);
  }
  backgroundSize() {
    return "cover";
  }
  backgroundPosition() {
    return "center";
  }
  mask() {
    return `${this.maskGeometry} exclude, ${this.maskGeometry} content-box`;
  }
  // mask() { return `${this.maskGeometry} center/100%` }
  // private maskGeometryasd = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${this.mixin.width} ${this.mixin.height}" width="100%" height="100%"><rect width="100%" height="100%" fill="none" rx="${this.mixin.cornerRadius ?? ""}" ry="${this.mixin.cornerRadius ?? ""}" stroke="#000" stroke-width="${(this.strokeHint.weight ?? 0)}" stroke-dasharray="${this.mixin.dashPattern?.join(" ") ?? ""}" /></svg>`
  // private maskGeometry = `url("data:image/svg+xml,${encodeURIComponent(this.maskGeometryasd)}")`
  // https://kovart.github.io/dashed-border-generator/
}
function tt(i, t) {
  switch (t) {
    case "FILL":
      return "100%";
    case "HUG":
      return "auto";
    case "FIXED":
    default:
      return l(i);
  }
}
class P extends G {
  constructor(t) {
    super(t), this.strokeMaskFragment = new Gt(this.node, this.getURLFromHash), this.fragments.push(this.strokeMaskFragment);
  }
  width() {
    return tt(this.node.width, this.node.layoutSizingHorizontal);
  }
  height() {
    return tt(this.node.height, this.node.layoutSizingVertical);
  }
  flexShrink() {
    if (this.parentNode.layoutMode !== "VERTICAL" && !(this.node.textAlignHorizontal != null && this.node.textAlignHorizontal !== "LEFT") && !(this.node.layoutSizingHorizontal != null && this.node.layoutSizingHorizontal !== "FIXED"))
      return 0;
  }
  background() {
    if (this.node.fills != null)
      return new K(this.node.fills, this.getURLFromHash);
  }
  borderRadius() {
    const t = this.node.cornerRadius ?? 0, e = [
      this.node.topLeftRadius ?? t,
      this.node.topRightRadius ?? t,
      this.node.bottomRightRadius ?? t,
      this.node.bottomLeftRadius ?? t
    ];
    if (Math.max(...e) !== 0)
      return e.map(l).join(" ");
  }
  overflow() {
    if (this.node.clipsContent)
      return "clip";
  }
  opacity() {
    var n, s, o;
    const t = this.node.opacity ?? 1, e = ((s = (n = this.node.fills) == null ? void 0 : n[0]) == null ? void 0 : s.type) === "IMAGE" ? ((o = this.node.fills) == null ? void 0 : o[0].opacity) ?? 1 : 1, r = t * e;
    if (r !== 1)
      return r;
  }
  mixBlendMode() {
    return L(this.node.blendMode);
  }
  boxShadow() {
    var e;
    const t = (e = this.node.effects) == null ? void 0 : e.flatMap((r) => r.type !== "DROP_SHADOW" && r.type !== "INNER_SHADOW" ? [] : r.visible === !1 ? [] : r.color.a === 0 ? [] : [`${r.type === "INNER_SHADOW" ? "inset" : ""} ${l(r.offset.x)} ${l(r.offset.y)} ${l(r.radius)} ${l(r.spread)} ${g.from(r.color)}`]);
    return t == null ? void 0 : t.join(", ");
  }
  filter() {
    var e;
    const t = (e = this.node.effects) == null ? void 0 : e.find((r) => !(r.type !== "LAYER_BLUR" || r.visible === !1));
    if (t != null)
      return `blur(${l(t.radius)})`;
  }
  backdropFilter() {
    var e;
    const t = (e = this.node.effects) == null ? void 0 : e.find((r) => !(r.type !== "BACKGROUND_BLUR" || r.visible === !1));
    if (t != null)
      return `blur(${l(t.radius)})`;
  }
}
class Wt extends P {
  borderRadius() {
    return "50%";
  }
}
class Vt extends P {
  display() {
    if (this.node.layoutMode === "HORIZONTAL")
      return "flex";
    if (this.node.layoutMode === "VERTICAL")
      return "grid";
  }
  flexWrap() {
    if (this.node.layoutMode === "HORIZONTAL")
      return this.node.layoutWrap === "WRAP" ? "wrap" : "nowrap";
  }
  gap() {
    return this.node.counterAxisSpacing != null ? `${l(this.node.itemSpacing)} ${l(this.node.counterAxisSpacing)}` : l(this.node.itemSpacing);
  }
  alignItems() {
    return L(this.node.counterAxisAlignItems);
  }
  justifyContent() {
    var e;
    const t = L(this.node.primaryAxisAlignItems);
    return t === "space-between" && ((e = this.node.children) == null ? void 0 : e.length) === 1 ? "center" : t;
  }
  padding() {
    const t = l(this.node.verticalPadding) ?? `${l(this.node.paddingTop)} ${l(this.node.paddingBottom)}`, e = l(this.node.horizontalPadding) ?? `${l(this.node.paddingLeft)} ${l(this.node.paddingRight)}`;
    return `${t} ${e}`;
  }
}
class Bt {
  constructor(t) {
    this.mixin = t;
  }
  get weight() {
    return l(this.mixin.strokeWeight ?? 1);
  }
  get style() {
    var t;
    return (((t = this.mixin.dashPattern) == null ? void 0 : t.length) ?? 0) > 0 ? "dashed" : "solid";
  }
  get color() {
    return this.mixin.strokes == null ? "red" : g.blend(...g.fromPaints(this.mixin.strokes));
  }
  get value() {
    return `${this.weight} ${this.style} ${this.color}`;
  }
}
class jt extends P {
  constructor(t) {
    super(t), this.dashed = this.node.dashPattern != null && this.node.dashPattern.length > 0, this.strokeMaskFragment.enabled = !1;
  }
  borderTop() {
    if (this.dashed)
      return new Bt(this.node);
  }
  height() {
    if (!this.dashed)
      return l(this.node.strokeWeight);
  }
  background() {
    if (!this.dashed)
      return new K(this.node.strokes ?? [], this.getURLFromHash);
  }
}
class Xt extends P {
  contain() {
    return "strict";
  }
  pointerEvents() {
    return "none";
  }
  top() {
  }
  left() {
  }
  position() {
    return "relative";
  }
}
class qt {
  constructor(t) {
    this.maxLines = t;
  }
  get value() {
    var t;
    return (t = this.maxLines) == null ? void 0 : t.toString();
  }
  get override() {
    if (this.maxLines != null)
      return {
        WebkitLineClamp: this.value,
        display: "-webkit-box",
        overflow: "hidden",
        boxOrient: "vertical",
        WebkitBoxOrient: "vertical"
      };
  }
}
class Yt extends M {
  constructor(t) {
    super(), this.align = t;
  }
  get display() {
    return "grid";
  }
  get alignContent() {
    if (this.align === "CENTER")
      return "center";
    if (this.align === "BOTTOM")
      return "end";
  }
}
class Qt extends P {
  constructor(t) {
    super(t), this.node.textAlignVertical != null && this.wrappers.push(new Yt(this.node.textAlignVertical));
  }
  width() {
    if (this.node.textAutoResize !== "WIDTH_AND_HEIGHT")
      return super.width();
  }
  height() {
    if (this.node.textAutoResize !== "HEIGHT" && this.node.textAutoResize !== "WIDTH_AND_HEIGHT")
      return super.height();
  }
  background() {
    if (this.hints.fills.hasImage)
      return super.background();
    if (this.hints.fills.hasGradient)
      return super.background();
  }
  color() {
    if (this.node.fills != null && !this.hints.fills.hasImage && !this.hints.fills.hasGradient)
      return g.blend(...g.fromPaints(this.node.fills)).toString();
  }
  overflowWrap() {
    return "break-word";
  }
  overflow() {
    if (this.node.textTruncation === "ENDING")
      return "clip";
  }
  textOverflow() {
    if (this.node.textTruncation === "ENDING")
      return "ellipsis";
  }
  textTransform() {
    if (this.node.textCase !== "ORIGINAL") {
      if (this.node.textCase === "LOWER")
        return "lowercase";
      if (this.node.textCase === "UPPER")
        return "uppercase";
      if (this.node.textCase === "TITLE")
        return "capitalize";
    }
  }
  whiteSpace() {
    var t;
    if ((t = this.node.characters) != null && t.includes(`
`))
      return "break-spaces";
  }
  letterSpacing() {
    return new Y(this.node.letterSpacing);
  }
  textDecoration() {
    var t;
    return (t = this.node.textDecoration) == null ? void 0 : t.toLowerCase();
  }
  leadingTrim() {
    if (this.node.leadingTrim === "CAP_HEIGHT")
      return "both";
  }
  textEdge() {
    if (this.node.leadingTrim === "CAP_HEIGHT")
      return "cap";
  }
  textStroke() {
    return this.WebkitTextStroke();
  }
  WebkitTextStroke() {
    var r;
    const t = (r = this.node.strokes) == null ? void 0 : r[0];
    if (t == null || t.type !== "SOLID")
      return;
    const e = new ut(t);
    return `${l(this.node.strokeWeight)} ${e.value}`;
  }
  textAlign() {
    if (this.node.textAlignHorizontal === "CENTER")
      return "center";
    if (this.node.textAlignHorizontal === "RIGHT")
      return "right";
  }
  verticalAlign() {
    if (this.node.textAlignVertical === "TOP")
      return "top";
    if (this.node.textAlignVertical === "CENTER")
      return "middle";
    if (this.node.textAlignVertical === "BOTTOM")
      return "bottom";
  }
  alignContent() {
    if (this.node.textAlignVertical === "TOP")
      return "start";
    if (this.node.textAlignVertical === "CENTER")
      return "center";
    if (this.node.textAlignVertical === "BOTTOM")
      return "end";
  }
  lineClamp() {
    return new qt(this.node.maxLines);
  }
  textIndent() {
    return this.node.paragraphIndent;
  }
  font() {
    return new at(this.node);
  }
  boxShadow() {
  }
  textShadow() {
    var e;
    const t = (e = this.node.effects) == null ? void 0 : e.flatMap((r) => r.type !== "DROP_SHADOW" ? [] : r.visible === !1 ? [] : r.color.a === 0 ? [] : [`${l(r.offset.x)} ${l(r.offset.y)} ${l(r.radius)} ${g.from(r.color)}`]);
    return t == null ? void 0 : t.join(", ");
  }
}
class Kt extends G {
}
class Jt {
  static create(t) {
    if (t.parentNode == null)
      return new Xt(t);
    const e = this.find(t.node.type);
    return new e(t);
  }
  static find(t) {
    switch (t) {
      case "FRAME":
        return Vt;
      case "TEXT":
        return Qt;
      case "GROUP":
        return G;
      case "WIDGET":
        return Kt;
      case "LINE":
        return jt;
      case "ELLIPSE":
        return Wt;
      default:
        return P;
    }
  }
}
class et extends Q {
  constructor() {
    super(...arguments), this.style = new G(this);
  }
  get height() {
    switch (this.node.type) {
      case "LINE":
        return this.node.strokeWeight ?? this.node.height;
      default:
        return this.node.height;
    }
  }
  get type() {
    return "svg";
  }
  get attributes() {
    const t = this.node.width ?? -1, e = this.height ?? -1;
    return {
      viewBox: `0 0 ${t} ${e}`,
      xmlns: "http://www.w3.org/2000/svg",
      style: { ...this.style.yield(), width: t, height: e }
    };
  }
  get children() {
    var r, n;
    const t = ((r = this.node.fillGeometry) == null ? void 0 : r.map((s) => rt(s, this.node.fills))) ?? [], e = ((n = this.node.strokeGeometry) == null ? void 0 : n.map((s) => rt(s, this.node.strokes))) ?? [];
    return [...t, ...e];
  }
  static isSVG(t) {
    switch (t.type) {
      case "STAR":
      case "POLYGON":
      case "VECTOR":
        return !0;
      default:
        return !1;
    }
  }
}
function rt(i, t) {
  return {
    type: "path",
    attributes: {
      d: i.data,
      fillRule: i.windingRule.toLowerCase(),
      fill: g.blend(...g.fromPaints(t ?? []))
    },
    children: []
  };
}
class J extends Q {
  constructor() {
    super(...arguments), this.style = Jt.create(this);
  }
  get type() {
    switch (this.node.type) {
      case "GROUP":
        return "section";
      case "TEXT":
        return "p";
      default:
        return "div";
    }
  }
  get attributes() {
    return {
      style: this.style.yield(),
      spellCheck: this.node.type === "TEXT" ? !1 : void 0
    };
  }
  get children() {
    var r;
    const t = this.yieldStyledNodes(this.style.fragments);
    return [...((r = this.node.children) == null ? void 0 : r.flatMap((n) => {
      if (n.visible === !1)
        return [];
      const s = this.createChild(n);
      return [this.nest(...s.wrappers, s)];
    })) ?? [], ...t];
  }
  get wrappers() {
    return this.yieldStyledNodes(this.style.wrappers);
  }
  createChild(t) {
    return et.isSVG(t) ? new et(t, this.node, this.resolvers) : new J(t, this.node, this.resolvers);
  }
  yieldStyledNode(t) {
    return {
      type: "div",
      attributes: { style: t.yield() },
      children: []
    };
  }
  yieldStyledNodes(t) {
    return t.flatMap((e) => e.enabled ? this.yieldStyledNode(e) : []);
  }
}
function lt(i, t) {
  wt(() => {
    if (i.current == null)
      return;
    const e = new ResizeObserver(t);
    return e.observe(i.current), () => e.disconnect();
  }, [i]);
}
function Zt(i) {
  const t = nt(null), [e, r] = st({ width: 0, height: 0 });
  function n(a) {
    r(a[0].contentRect.toJSON());
  }
  lt(t, n);
  const s = i.node.width ?? 1, o = i.node.height ?? 1;
  return /* @__PURE__ */ p("div", { style: {
    position: "relative",
    overflow: "hidden",
    contain: "size",
    aspectRatio: `${s} / ${o}`,
    width: s >= o ? "100%" : void 0,
    height: o >= s ? "100%" : void 0
  }, ref: t, children: /* @__PURE__ */ p(_t, { ...i, ...e }) });
}
function _t(i) {
  var r, n;
  const t = i.width / (((r = i.node) == null ? void 0 : r.width) ?? 1), e = i.height / (((n = i.node) == null ? void 0 : n.height) ?? 1);
  return ot(i.element, {
    style: {
      ...i.element.props.style,
      position: "absolute",
      scale: `${t} ${e}`,
      transformOrigin: "left top"
    }
  });
}
function te(i) {
  const t = nt(null), [e, r] = st({ width: 0, height: 0 });
  function n(s) {
    r(s[0].contentRect.toJSON());
  }
  return lt(t, n), /* @__PURE__ */ p("div", { style: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    height: "100%"
  }, ref: t, children: /* @__PURE__ */ p(ee, { ...i, ...e }) });
}
function ee(i) {
  var r, n;
  const t = i.width / (((r = i.node) == null ? void 0 : r.width) ?? 1), e = i.height / (((n = i.node) == null ? void 0 : n.height) ?? 1);
  return ot(i.element, {
    style: {
      ...i.element.props.style,
      position: "absolute",
      scale: `${t} ${e}`,
      transformOrigin: "left top"
    }
  });
}
function re(i) {
  var e, r;
  const t = z(() => {
    const n = new J(i.design.rootNode, null, i.resolvers);
    return new U(n).toReactElement();
  }, [i.design, i.resolvers]);
  return ((e = i.options) == null ? void 0 : e.fit) === "fill" ? /* @__PURE__ */ p(te, { node: i.design.rootNode, element: t }) : ((r = i.options) == null ? void 0 : r.fit) === "contain" ? /* @__PURE__ */ p(Zt, { node: i.design.rootNode, element: t }) : t;
}
const ct = yt(/* @__PURE__ */ new Map());
class ie {
  /**
   * @argument locale default `"EN"`
   */
  static format(t, e = "EN", r) {
    try {
      return t.toLocaleString(e, { ...ne, ...r });
    } catch (n) {
      if (n instanceof Error)
        return n.message.includes("tag") || n.message.includes("locale") ? "Invalid language tag" : "Invalid currency code";
      throw n;
    }
  }
  /**
   * @returns price value without currency sign
   */
  static parseValue(t) {
    return Number(t.replace(/[^\d.,]/g, "").replace(",", "."));
  }
}
const ne = {
  style: "currency",
  currency: "USD"
};
function mt(i) {
  const t = xt(ct);
  return z(() => {
    const r = t.get(i);
    return r ?? {
      id: "-1",
      price: -1,
      title: "[ID is not found]"
    };
  }, [i, t]);
}
function dt(i) {
  return /* @__PURE__ */ p("div", { style: { textDecoration: "line-through" }, children: i.children });
}
function se(i) {
  var r;
  const t = mt(i.entity.id), e = /* @__PURE__ */ p(it, { children: t.title });
  return (r = t.effects) != null && r.includes("STRIKE_THROUGH") ? /* @__PURE__ */ p(dt, { children: e }) : e;
}
function oe(i) {
  var r;
  const t = mt(i.entity.id), e = /* @__PURE__ */ p(it, { children: t.price && ie.format(t.price) });
  return t.priceOverride != null ? t.priceOverride : (r = t.effects) != null && r.includes("STRIKE_THROUGH") ? /* @__PURE__ */ p(dt, { children: e }) : e;
}
function ae(i) {
  return z(() => i.entity.type === F.MenuItemTitle ? /* @__PURE__ */ p(se, { entity: i.entity }) : i.entity.type === F.MenuItemPrice ? /* @__PURE__ */ p(oe, { entity: i.entity }) : i.content, [i]);
}
function de({ items: i, ...t }) {
  const e = z(() => Et(i), [i]);
  return /* @__PURE__ */ p(ct.Provider, { value: e, children: /* @__PURE__ */ p(
    re,
    {
      ...t,
      resolvers: {
        imageHash: t.mapImageHashToUrl,
        transformText(r, n) {
          return /* @__PURE__ */ p(ae, { content: r, entity: n });
        },
        transformWidget() {
        }
      }
    }
  ) });
}
export {
  St as Design,
  re as DesignViewer,
  me as MenuDesign,
  de as MenuDesignViewer
};
//# sourceMappingURL=index.js.map
